import React from "react";
import { Modal, Button, ModalBody } from "reactstrap";


function SuccessFailureScreen(props) {
  const { status, isOpen, modalType, toggleModal, statusMessage } = props;

  const getMessage = () => {
    switch (modalType) {
      case "payment":
        return status === "success" ? (statusMessage || "Payment successful") : statusMessage;
      case "signature":
        return statusMessage;
      default:
        return "";
    }
  };

  return (
    <Modal isOpen={isOpen} centered>
      <ModalBody className="m-auto text-center">
        <img className="mt-3" src={status === "success" ? process.env.REACT_APP_IMAGES_PATH + "success1.webp" : process.env.REACT_APP_IMAGES_PATH + "failure_1.webp"} alt="result-icon" />

        <h5 className="mt-2 p-2" dangerouslySetInnerHTML={{ __html: getMessage() }} />
        {props?.paymentLinkRes && props?.paymentLinkRes.length ?
          <div className="m-auto w-80 d-flex justify-content-around">
            <a href={props?.paymentLinkRes} target="_blank" className="btn btn-outline-dark">Make the Payment</a>
            <Button
              // style={{ color: "#283A97" }}
              // size="sm"
              // color={"link"}
              onClick={() => {
                toggleModal(false);
              }}
            >
              {"Close"}
            </Button>
          </div> :
          <Button
            style={{ color: "#283A97" }}
            size="sm"
            color={"link"}
            onClick={() => {
              toggleModal(false);
            }}
          >
            {"Close"}
          </Button>}
      </ModalBody>
    </Modal>
  );
}
export default SuccessFailureScreen;